// German — mirrors src/i18n/local/en/common.ts
// Translations reflect Forwaro's B2B export context (German-speaking buyers in DE/AT/CH).

const common = {
  // Navigation
  "nav.home": "Startseite",
  "nav.products": "Produkte",
  "nav.factory": "Fabrik",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.requestQuote": "Angebot anfordern",
  "nav.menu": "Menü",
  "nav.language": "Sprache",

  // CTAs
  "cta.requestQuote": "Angebot anfordern",
  "cta.exploreCatalog": "Katalog ansehen",
  "cta.contactUs": "Kontakt aufnehmen",
  "cta.scheduleFactoryVisit": "Werksbesichtigung vereinbaren",
  "cta.requestSample": "Muster anfordern",
  "cta.viewAll": "Alle Produkte ansehen",

  // Common
  "common.tbd": "[Von Forwaro zu bestätigen]",
  "common.category": "Kategorie",
  "common.material": "Material",
  "common.style": "Stil",
  "common.filters": "Filter",
  "common.resetAll": "Zurücksetzen",
  "common.details": "Details",

  // Brand
  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",
  "whatsapp.cta": "Nachricht über WhatsApp",
  "wechat.cta": "Auf WeChat hinzufügen",

  // Home · Hero
  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "Zuhause ist",
  "home.hero.headline.line2Highlight": "das Zentrum",
  "home.hero.headline.line3": "eines geschäftigen Lebens.",
  "home.hero.subheadline": "Forwaro Furniture (風華國際) ist ein OEM-/ODM-Hersteller mit Sitz in Dongguan und verbindet Möbeldesign mit gleichbleibender Produktionsqualität für Importeure im Nahen Osten, in Europa, Amerika und Asien.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "Produktlinien",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "Maßgefertigte Produktion",
  "home.hero.stat3.value": "Dongguan",
  "home.hero.stat3.label": "Min-Tian-Industriezone",
  "home.hero.stat4.value": "Weltweit",
  "home.hero.stat4.label": "Exportpartnerschaften",
  "home.hero.scroll": "Scrollen",

  // Home · Categories
  "home.categories.kicker": "Unser Produktprogramm",
  "home.categories.heading": "Sechs Produktlinien, eine Fabrik, der man vertraut",
  "home.categories.description": "Esstische, Couchtische, Konsolentische, Stühle, Sofas und TV-Möbel: die sechs B2B-Möbellinien, die Forwaro für den Export fertigt.",

  // Home · About
  "home.about.kicker": "Über Forwaro",
  "home.about.heading.line1": "Möbeldesign,",
  "home.about.heading.line2": "konsequent verarbeitet.",
  "home.about.philosophy.en":
    "Zuhause ist das Zentrum eines geschäftigen Lebens, in dem die Ästhetik des Wohnens zum Geschmack und Anliegen erfolgreicher Menschen überall wird. Forwaro Furniture steht für Designkonsequenz und verlässliche Produktionsqualität — damit Ästhetik und Handwerk im Zuhause einander ergänzen.",
  "home.about.location": "Forwaro Furniture (風華國際有限公司) wurde 1991 in Taiwan gegründet und fertigt seit 2006 auf dem chinesischen Festland. Heute ist das Unternehmen in der Min Tian Industrial Zone in Shatian Town, Dongguan, ansässig. Forwaro arbeitet mit Importeuren zusammen, die ehrliche Handwerkskunst und zuverlässige Lieferung schätzen.",
  "home.about.highlight1.title": "OEM & ODM",
  "home.about.highlight1.body":
    "Maßgeschneiderte Fertigung — von Private-Label-Serien bis zur vollständigen Entwicklung.",
  "home.about.highlight2.title": "Exportgerechte QS",
  "home.about.highlight2.body":
    "Prüfung bei Holzarbeit, Polsterei, Oberflächen und Verpackung für den Überseetransport.",
  "home.about.highlight3.title": "Naturmarmor & Stahl",
  "home.about.highlight3.body": "Markante Tischplatten aus Naturmarmor, kombiniert mit galvanisierten Gestellen aus Edelstahl und Eisen.",
  "home.about.highlight4.title": "Globale Exportreichweite",
  "home.about.highlight4.body": "Von Dongguan aus beliefern wir Importeure im Nahen Osten, in Europa, Amerika und Asien.",
  "home.about.badgeLocation": "Dongguan, China",
  "home.about.badgeZone": "Min-Tian-Industriezone",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "Maßgefertigt & Private Label",

  // Home · Featured
  "home.featured.kicker": "Katalog-Vorschau",
  "home.featured.heading": "Eine Vorschau auf Forwaros sechs Produktlinien",
  "home.featured.description": "Echte Forwaro-Modellcodes mit bestätigten Materialien und Maßen. Kontaktieren Sie uns für die vollständigen Spezifikationen und ein Angebot.",

  // Home · Markets
  "home.markets.kicker": "Globale Reichweite",
  "home.markets.heading": "Unsere Exportmärkte",
  "home.markets.description":
    "Forwaro arbeitet mit Möbelimporteuren, Vertrieben, Hotelgruppen und Wohnprojekten auf vier Kontinenten.",

  // Home · Process
  "home.process.heading": "So arbeiten wir mit Ihnen",
  "home.process.description":
    "Von der ersten Anfrage bis zur Container-Verladung — der Standard-Exportablauf von Forwaro.",

  // Footer
  "footer.getInTouch.kicker": "Kontakt",
  "footer.getInTouch.heading":
    "Starten Sie Ihre Möbel-Importreise\nmit Forwaro",
  "footer.getInTouch.description":
    "Unser Exportteam erstellt individuelle Angebote, stellt Muster bereit und liefert vollständige Exportdokumente für Ihren Markt.",
  "footer.contact.email": "E-Mail",
  "footer.contact.phone": "Telefon",
  "footer.contact.fax": "Fax",
  "footer.contact.factory": "Fabrik",
  "footer.contact.whatsappNote":
    "WhatsApp- und WeChat-Kanäle — werden von Forwaro bestätigt.",
  "footer.form.heading": "Angebot anfordern",
  "footer.form.name": "Vollständiger Name",
  "footer.form.email": "E-Mail",
  "footer.form.company": "Unternehmen",
  "footer.form.country": "Land",
  "footer.form.countryPlaceholder": "Land auswählen",
  "footer.form.message": "Nachricht",
  "footer.form.messagePlaceholder":
    "Beschreiben Sie Anforderungen, Mengen und Zielmarkt…",
  "footer.form.submit": "Anfrage senden",
  "footer.form.sending": "Sende…",
  "footer.form.success.heading": "Gesendet!",
  "footer.form.success.body":
    "Unser Exportteam meldet sich innerhalb von zwei Werktagen.",
  "footer.form.sendAnother": "Weitere Nachricht senden",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱. OEM/ODM-Hersteller mit Sitz in Dongguan, der Importeure im Nahen Osten, in Europa, Amerika und Asien beliefert.",
  "footer.col.products": "Produkte",
  "footer.col.company": "Unternehmen",
  "footer.col.markets": "Exportmärkte",
  "footer.col.regional": "Sie suchen eine regionale Vertretung?",
  "footer.copyright": "Alle Rechte vorbehalten.",
};

export default common;
